// extracted by mini-css-extract-plugin
export default {"issue":"FeedbackMessage_issue__CGLiW","link":"FeedbackMessage_link__G1Njr"};